// 全局用户信息管理器
class UserInfoManager {
  private static instance: UserInfoManager;
  private currentUser: any = null;

  private constructor() {}

  public static getInstance(): UserInfoManager {
    if (!UserInfoManager.instance) {
      UserInfoManager.instance = new UserInfoManager();
    }
    return UserInfoManager.instance;
  }

  public setCurrentUser(user: any) {
    this.currentUser = user;
  }

  public getCurrentUser() {
    return this.currentUser;
  }

  public getCurrentUserName(): string {
    return this.currentUser?.name || 'admin';
  }
}

export const userInfoManager = UserInfoManager.getInstance();
